/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBoardBarsIcon20Light = forwardRef('DataChartBoardBarsIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.5 8.5A.5.5 0 0 1 6 9v1.5a.5.5 0 1 1-1 0V9a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M12 7.75a.5.5 0 1 0-1 0v2.75a.5.5 0 1 0 1 0V7.75Z" }),
        React.createElement("path", { d: "M8.5 6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M15 5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1.82l1.047 3.35a.5.5 0 1 1-.954.3L12.133 14H7.867l-1.14 3.65a.5.5 0 1 1-.955-.3L6.82 14H5a3 3 0 0 1-3-3V5Zm3-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z" })));
});
